import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import styles from './cartEmpty.module.scss';

const CartEmpty: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.container__title_block}>
        <p className={styles.container__title}>Корзина пуста</p>
      </div>
      <Link
        className={classNames('button button--md-black', styles.container__btn)}
        href="/"
      >
        Перейти к покупкам
      </Link>
    </div>
  );
};

export default CartEmpty;
